import { useEffect, useState, type ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { checkAdminAccess } from "@/lib/adminAccess";

export default function AdminOnly({ children }: { children: ReactNode }) {
  const [access, setAccess] = useState<"loading" | "signed-out" | "denied" | "authorized">("loading");
  const location = useLocation();

  useEffect(() => {
    let active = true;
    let generation = 0;
    const refresh = async () => {
      const current = ++generation;
      if (active) setAccess("loading");
      const result = await checkAdminAccess();
      if (active && current === generation) setAccess(result);
    };
    void refresh();
    const { data: { subscription } } = supabase.auth.onAuthStateChange(() => {
      // Don't await another auth call inside the auth callback.
      if (active) setAccess("loading");
      queueMicrotask(() => { if (active) void refresh(); });
    });
    return () => { active = false; generation++; subscription.unsubscribe(); };
  }, []);

  if (access === "loading") return <div role="status" className="min-h-screen flex items-center justify-center bg-background"><div className="w-8 h-8 border-2 border-primary/30 border-t-primary rounded-full animate-spin" /><span className="sr-only">Vérification de votre accès…</span></div>;
  if (access === "signed-out") return <Navigate to="/mon-compte" state={{ from: location.pathname }} replace />;
  if (access !== "authorized") return <Navigate to="/" replace />;
  return <>{children}</>;
}